import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/es5/locale/pt';
// import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#795548',
        secondary: '#607d8b',
        accent: '#00bcd4',
        error: "#f44336",
        warning: '#ffc107',
        info: '#03a9f4',
        success: '#4caf50'
      },
    },
  },
    lang: {
      locales: { pt },
      current: 'pt',
    },
  icons: {
    iconfont: 'mdi',
  },
});
